import React, { useState } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import CardList from "../components/cardList"
/** @jsx jsx */
import { jsx, Styled } from "theme-ui"
import Dropdown from "../components/dropdown"

export const neighborhoodOpts = [
  {
    label: "North",
    value: "north",
  },
  {
    label: "Northwest",
    value: "northwest",
  },
  {
    label: "Northeast",
    value: "northeast",
  },
  {
    label: "Southeast",
    value: "southeast",
  },
  {
    label: "Downtown",
    value: "downtown",
  },
]

export const dietOpts = [
  {
    label: "Vegan",
    value: "vegan",
  },
  {
    label: "Vegetarian",
    value: "vegetarian",
  },
  {
    label: "Gluten Free",
    value: "gluten free",
  },
]

export type NeighborHoods =
  | "north"
  | "northwest"
  | "northeast"
  | "southeast"
  | "downtown"

export type Diets = "vegan" | "vegetarian" | "gluten free"

const IndexPage = () => {
  const [filter, setFilter] = useState<NeighborHoods>(null)
  const [diet, setDiet] = useState<Diets>(null)
  return (
    <Layout>
      <SEO title="Home" />
      <div
        sx={{
          my: 3,
          py: 2,
          display: "grid",
          gridTemplateColumns: ['1fr', '2fr 1fr'],
          gridGap: 4,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Styled.p>
          Portland Nacho Week by{" "}
          <a
            href="https://www.portlandmercury.com/events/nachoweek"
            target="_blank"
          >
            Portland Mercury
          </a>
        </Styled.p>
        <div sx={{ display: "flex", flexDirection: "column", minWidth: '20rem' }}>
          <Dropdown
            placeholder="Neighborhood"
            options={neighborhoodOpts}
            selected={neighborhoodOpts.find(opt => opt.value === filter)}
            onChange={selected => setFilter(selected)}
            sx={{ mb: 3 }}
          />
          <Dropdown
            placeholder="Dietary Opts"
            options={dietOpts}
            selected={dietOpts.find(opt => opt.value === diet)}
            onChange={selected => setDiet(selected)}
          />
        </div>
      </div>
      <CardList filter={filter} diet={diet} />
    </Layout>
  )
}

export default IndexPage
